import React, { useState, useEffect, useCallback } from "react";
import { PropertyService } from "../../services/property";
import { useParams } from "react-router-dom";
import PropertyDetails from "pages/Property-Details/Property-Details";
import TenantDetails from "pages/TenantDetails/TenantDetails";
import Loader from "components/Loader/Loader";
import ExpenseDetails from "pages/Expenses/ExpenseDetails";
import Units from "pages/Units/Units";

const PropertyDashboard: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const { propertyid } = useParams<{ propertyid: string }>();
  const [propertyDetails, setPropertyDetails] = useState<any>({});
  const [tenantList, setTenantList] = useState<any>({});
  const [expenseList, setExpenseList] = useState<any>({});
  const [unitList, setUnitList] = useState<any>({});

  const loadPropertyDetails = useCallback(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const data = await PropertyService.fetchProperty(Number(propertyid));

        console.log(data);
        setPropertyDetails(data.property.property); // Assuming the structure matches your API response
        setTenantList(data.property.tenants);
        setExpenseList(data.property.expenses);
        setUnitList(data.property.units);

        console.log(data.property.units);
      } catch (err: any) {
        console.error("Error fetching property details:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [propertyid]);

  useEffect(() => {
    loadPropertyDetails();
  }, [loadPropertyDetails]);

  const reloadProperty = async () => {
    try {
      // Assuming you have a POST method to update the property
      loadPropertyDetails();
    } catch (err) {
      alert("Failed to update property");
    }
  };

  return (
    <div>
      {loading ? (
        <Loader />
      ) : (
        <div className="bg property-dashboard">
          <h1 className="dashboard-header">
            {propertyDetails.streetAddress} Dashboard
          </h1>

          <div className="module-container">
            <div className="module">
              <PropertyDetails
                propertyDetails={propertyDetails}
                onPropertyUpdate={reloadProperty}
              />
            </div>
            {propertyDetails.isMultiFamily && (
              <div className="module">
                <Units
                  units={unitList}
                  propertyDetails={propertyDetails}
                  onUnitsUpdated={reloadProperty}
                  tenantList={tenantList}
                />
              </div>
            )}
            <div className="module">
              <TenantDetails
                tenantList={tenantList}
                onTenantUpdate={reloadProperty}
                propertyDetails={propertyDetails}
              />
            </div>
            <div className="module">
              <div style={{ marginTop: "24px" }}>
                <ExpenseDetails
                  propertyDetails={propertyDetails}
                  expenseList={expenseList}
                  onExpenseUpdate={reloadProperty}
                />
              </div>
            </div>
            {/* 
              <div className='module'>
              <PropertyDetails
                propertyDetails={propertyDetails} // Pass the details down
                onPropertyUpdate={updatePropertyDetails} // Callback to handle updates
              />
            </div> */}
          </div>
        </div>
      )}
    </div>
  );
};

export default PropertyDashboard;
